// custom typefaces
import "@fontsource-variable/montserrat"
import "@fontsource/merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"
// Import Atkinson Hyperlegible from Fontsource
import "@fontsource/atkinson-hyperlegible"
import "@fontsource/atkinson-hyperlegible-mono"
import "@fontsource/atkinson-hyperlegible-next"
// Import Maple Mono for code blocks
import "@fontsource/maple-mono"

// Highlighting for code blocks, pick one of the following lines...
//import "prismjs/themes/prism-okaidia.css"
//import "prismjs/themes/prism-funky.css"
import "prismjs/themes/prism-tomorrow.css"

const fallbackCopy = (text, button) => {
  const textArea = document.createElement('textarea')
  textArea.value = text
  textArea.style.position = 'fixed'
  textArea.style.left = '-999999px'
  textArea.style.top = '-999999px'
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()
  try {
    document.execCommand('copy')
    button.innerHTML = '<i class="fas fa-check"></i>'
    setTimeout(() => {
      button.innerHTML = '<i class="fas fa-copy"></i>'
    }, 2000)
  } catch (err) {
    console.error('Fallback copy failed: ', err)
  }
  document.body.removeChild(textArea)
}

export const onRouteUpdate = () => {
  const codeBlocks = document.querySelectorAll('pre')
  codeBlocks.forEach((pre) => {
    const highlightContainer = pre.closest('.gatsby-highlight')
    if (!highlightContainer || highlightContainer.querySelector('.copy-button')) return // already added
    
    // Create a wrapper for the scrollable content
    const scrollWrapper = document.createElement('div')
    scrollWrapper.className = 'code-scroll-wrapper'
    scrollWrapper.style.overflow = 'auto'
    
    // Move the pre element into the scroll wrapper
    pre.parentNode.insertBefore(scrollWrapper, pre)
    scrollWrapper.appendChild(pre)
    
    // Create the copy button
    const button = document.createElement('button')
    button.className = 'copy-button'
    button.innerHTML = '<i class="fas fa-copy"></i>'
    button.title = 'Copy code'
    button.addEventListener('click', () => {
      const code = pre.querySelector('code')
      if (code) {
        const text = code.textContent
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(() => {
            button.innerHTML = '<i class="fas fa-check"></i>'
            setTimeout(() => {
              button.innerHTML = '<i class="fas fa-copy"></i>'
            }, 2000)
          }).catch((err) => {
            console.error('Failed to copy: ', err)
            fallbackCopy(text, button)
          })
        } else {
          fallbackCopy(text, button)
        }
      }
    })
    highlightContainer.appendChild(button)
  })
}
